import { render, staticRenderFns } from "./NotifictaionWorks.vue?vue&type=template&id=293dddde&"
import script from "./NotifictaionWorks.vue?vue&type=script&lang=js&"
export * from "./NotifictaionWorks.vue?vue&type=script&lang=js&"
import style0 from "./NotifictaionWorks.vue?vue&type=style&index=0&id=293dddde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports